export const createMenuItem = /* GraphQL */ `mutation CreateMenuItem($input: inputCreateMenuItem!) {
	createMenuItem(input: $input){
        id
        menuItemType
    }
}`
